import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StatusDate from '../StatusDate';
import IconStand from '../IconStand';
import OrderStatusIcon from './OrderStatusIcon';
import { lastEventShape } from '../statusHelper';
import { Heading } from '../../StyledComponents';
import styles from './OrderStatus.module.scss';

class OrderStatus extends React.PureComponent {

  render() {
    const {
      message,
      icon,
      date,
      showIcon,
      isMobile,
      designSettings: {
        bodyHeadingsColor,
        bodyTextColor,
        iconBackgroundColor,
        iconColor,
        bodyFontSize,
        bodyFont,
        headingFontSize,
        headingFont,
      },
      locale,
    } = this.props;

    return (
      <div styleName={classNames('order-status', { mobile: isMobile })}>
        { showIcon && (
          <IconStand size={ isMobile ? 80 : 100 } iconBackgroundColor={iconBackgroundColor}>
            <OrderStatusIcon name={icon} size={ isMobile ? 24 : 32 } fill={iconColor} />
          </IconStand>
        ) }
        <div className={styles.header}>
          <Heading
            type="headingPrimary"
            isMobile={isMobile}
            fontSize={headingFontSize}
            font={headingFont}
            color={bodyHeadingsColor}
          >
            {message}
          </Heading>
        </div>
        { date && (
          <StatusDate
            isMobile={isMobile}
            date={date}
            fontSize={bodyFontSize}
            font={bodyFont}
            color={bodyTextColor}
            locale={locale}
          />
        )}
      </div>
    );
  }
}

OrderStatus.propTypes = {
  ...lastEventShape,
  showIcon: PropTypes.bool,
  designSettings: PropTypes.shape({
    headingFont:PropTypes.string,
    headingFontSize: PropTypes.string,
    bodyFont:PropTypes.string,
    bodyFontSize:PropTypes.string,
    bodyHeadingsColor: PropTypes.string,
    bodyTextColor: PropTypes.string,
    iconBackgroundColor: PropTypes.string,
    iconColor: PropTypes.string,
  }),
  locale: PropTypes.string,
};

export default OrderStatus;



// WEBPACK FOOTER //
// ./src/js/widgets/Status/OrderStatus/OrderStatus.js